<template>
  <div>
    <b-row
      class="content-header"
    >

      <!-- Content Left -->
      <b-col
        class="content-header-left mb-2"
        cols="12"
        md="12"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h1 class="custom-header-title">
              {{ code.sclcID }} - {{ code.name }}
            </h1>
            <p class="log_info">
              Created by {{ code.createdBy ? code.createdBy.name : '' }} on {{ dateFormatWithTime(code.createdAt) }} <br>Last updated on {{ dateFormatWithTime(code.updatedAt) }}
            </p>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <b-card
          header-tag="header"
          class=""
        >
          <div class="d-flex justify-content-between">
            <b-table-simple
              borderless
              responsive
              class="custom-th-width"
            >
              <b-tbody>
                <b-tr>
                  <b-th width="230">
                    Product Code
                  </b-th>
                  <b-td class="mt-50">
                    {{ code.code || '-' }}
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230">
                    Product Description
                  </b-th>
                  <b-td class="mt-50">
                    {{ code.name || '-' }}
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230">
                    Product Category
                  </b-th>
                  <b-td class="mt-50">
                    {{ code.category ? code.category.name : '-' }}
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230">
                    Lot Based
                  </b-th>
                  <b-td class="mt-50">
                    {{ code.lotBased ? 'Yes' : 'No' }}
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230">
                    File Sequence Prefix
                  </b-th>
                  <b-td class="mt-50">
                    {{ code.fileSequence || '-' }}
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230">
                    CN Discount Code
                  </b-th>
                  <b-td class="mt-50">
                    {{ code.cnDiscountCode || '-' }}
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
            <b-button
              v-if="canViewThisAction('update', 'ProductCode')"
              variant="flat-primary"
              class="display-content"
              :to="{ name: 'products-codes-edit', params: { id: $route.params.id } }"
            >
              <feather-icon
                icon="EditIcon"
                class="mr-50"
                size="16"
              />
              <span class="align-middle">Edit</span>
            </b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <!-- Need Types Section -->
    <b-row v-if="canViewThisAction('read', 'ProductNeedType')">
      <b-col md="12">
        <b-card
          no-body
          class="shadow-none need-types-card"
        >
          <div class="d-flex justify-content-between align-items-center need-types-header">
            <h4 class="mb-0">
              Need Types
            </h4>
            <div class="d-flex align-items-center">
              <b-input-group
                v-if="showSearchBar"
                class="input-group-merge mr-50"
              >
                <b-form-input
                  v-model="searchQuery"
                  placeholder="Search need types..."
                />
                <b-input-group-append is-text>
                  <feather-icon
                    icon="XIcon"
                    class="cursor-pointer"
                    @click="searchQuery = ''; showSearchBar = false"
                  />
                </b-input-group-append>
              </b-input-group>
              <a
                href="javascript:void(0)"
                class="nav-link nav-link-search p-0 flex-shrink-0"
                style="white-space: nowrap;"
                @click="showSearchBar = !showSearchBar"
              >
                <feather-icon
                  icon="SearchIcon"
                  size="21"
                  class="mr-50"
                />
                <span class="align-middle">Search</span>
              </a>
            </div>
          </div>
          <b-table
            :items="filteredNeedTypes"
            :fields="needTypeFields"
            responsive
            show-empty
            empty-text="No need types found."
            class="mb-0 shadow-table"
          >
            <template #cell(availableToAgents)="data">
              {{ data.item.availableToAgents ? 'Yes' : 'No' }}
            </template>
            <template #cell(displayLabel)="data">
              {{ data.item.displayLabel || '-' }}
            </template>
            <template #cell(createdBy)="data">
              <span v-if="data.item.createdBy">
                {{ data.item.createdBy.name }}<br>
                <span class="">{{ dateFormatWithTime(data.item.createdAt) }}</span>
              </span>
              <span v-else>-</span>
            </template>
            <template #cell(updatedBy)="data">
              <span v-if="data.item.updatedBy">
                {{ data.item.updatedBy.name }}<br>
                <span class="">{{ dateFormatWithTime(data.item.updatedAt) }}</span>
              </span>
              <span v-else>-</span>
            </template>
            <template
              v-if="canViewThisAction('update', 'ProductNeedType')"
              #cell(actions)="data"
            >
              <b-dropdown
                variant="link"
                no-caret
                :right="$store.state.appConfig.isRTL"
              >
                <template #button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="align-middle text-body"
                  />
                </template>
                <b-dropdown-item :to="{ name: 'products-need-type-edit', params: { id: data.item._id } }">
                  <feather-icon
                    icon="EditIcon"
                    class="mr-50"
                  />
                  <span>Edit</span>
                </b-dropdown-item>
                <b-dropdown-item @click="toggleAvailable(data.item)">
                  <feather-icon
                    :icon="data.item.availableToAgents ? 'EyeOffIcon' : 'EyeIcon'"
                    class="mr-50"
                  />
                  <span>{{ data.item.availableToAgents ? 'Mark unavailable for agents' : 'Mark available for agents' }}</span>
                </b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BButton, BTableSimple, BTbody, BTr, BTd, BTh,
  BTable, BDropdown, BDropdownItem, BFormInput, BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import store from '@/store/index'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import '@core/scss/vue/libs/vue-flatpicker.scss'
import { useUtils as useAclUtils } from '@/libs/acl/custom'
import needTypeStoreModule from '../needTypes/needTypeStoreModule'

const NEED_TYPE_STORE_MODULE_NAME = 'app-need-type'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BTableSimple,
    BTbody,
    BTh,
    BTr,
    BTd,
    BTable,
    BDropdown,
    BDropdownItem,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  directives: {
    Ripple,
  },
  setup() {
    const { canViewThisAction } = useAclUtils()
    return { canViewThisAction }
  },
  data() {
    return {
      code: {},
      needTypes: [],
      searchQuery: '',
      showSearchBar: false,
      needTypeFields: [
        { key: 'needType', label: 'Need Type' },
        { key: 'availableToAgents', label: 'Available to Agents' },
        { key: 'displayLabel', label: 'Display Label' },
        { key: 'createdBy', label: 'Created By' },
        { key: 'updatedBy', label: 'Last Updated By' },
        { key: 'actions', label: 'Actions' },
      ],
      required,
    }
  },
  computed: {
    filteredNeedTypes() {
      if (!this.searchQuery) return this.needTypes
      const q = this.searchQuery.toLowerCase()
      return this.needTypes.filter(nt => (nt.needType || '').toLowerCase().includes(q)
        || (nt.displayLabel || '').toLowerCase().includes(q))
    },
  },
  created() {
    if (!store.hasModule(NEED_TYPE_STORE_MODULE_NAME)) {
      store.registerModule(NEED_TYPE_STORE_MODULE_NAME, needTypeStoreModule)
    }

    this.$http.get(`reservation/product-code/${this.$route.params.id}`)
      .then(response => {
        this.code = response.data

        store.commit('breadcrumb/REMOVE_BREADCRUMB')
        const newMeta = {
          active: true,
          text: this.code.name,
        }
        store.commit('breadcrumb/UPDATE_BREADCRUMB', newMeta)

        return store.dispatch(`${NEED_TYPE_STORE_MODULE_NAME}/fetchNeedTypesByCode`, { codeId: this.$route.params.id })
      })
      .then(response => {
        if (response) this.needTypes = response.data.needTypes || []
      })
      .catch(error => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.data?.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  },
  methods: {
    toggleAvailable(item) {
      store.dispatch(`${NEED_TYPE_STORE_MODULE_NAME}/toggleAvailable`, { id: item._id })
        .then(response => {
          const idx = this.needTypes.findIndex(nt => nt._id === item._id)
          if (idx !== -1) {
            this.$set(this.needTypes, idx, response.data.data)
          }
          this.$toast({
            component: ToastificationContent,
            props: {
              title: response.data.message,
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data?.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
  },
}
</script>

<style lang="scss">
  .item-field-custom-class {
    color: #000000;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
  }
  .display-content {
    display: contents;
  }

  .custom-th-width {
    .table th {
        padding: 0.72rem 2rem 0.72rem 0.72rem;
    }
  }

  .content-body .card.need-types-card {
    padding: 40px !important;
  }

  .need-types-header {
    margin-bottom: 18px !important;
  }
</style>
